import { render, staticRenderFns } from "./deleteApplyWithholdIntegral.vue?vue&type=template&id=480800c9&scoped=true"
import script from "./deleteApplyWithholdIntegral.vue?vue&type=script&lang=js"
export * from "./deleteApplyWithholdIntegral.vue?vue&type=script&lang=js"
import style0 from "./deleteApplyWithholdIntegral.vue?vue&type=style&index=0&id=480800c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480800c9",
  null
  
)

export default component.exports